import React from 'react'
import styled from 'styled-components'
import LockIcon from '@mui/icons-material/Lock'

export const IDENTITY_RESTRICTED_TEXT = 'Personal ID documents are restricted. Ask your administrator for access.'
export const IDENTITY_PENDING_TEXT = 'This document is still being checked. It will be available in a few minutes.'
export const IDENTITY_UNREADABLE_TEXT = "This document couldn't be checked automatically. Your administrator needs to review it before others can see it."

const noteText = ({ pending, unreadable }) => {
  if (unreadable) return IDENTITY_UNREADABLE_TEXT
  return pending ? IDENTITY_PENDING_TEXT : IDENTITY_RESTRICTED_TEXT
}

export const identityRestrictionText = file => noteText({ pending: file?.isIdentityPending, unreadable: file?.isIdentityUnreadable })

const IdentityRestrictedNote = ({ pending = false, unreadable = false }) => (
  <Note role='note'>
    <LockIcon style={{ fontSize: 14 }} aria-hidden='true' />
    {noteText({ pending, unreadable })}
  </Note>
)

export default IdentityRestrictedNote

const Note = styled.span`
  display: inline-flex;
  align-items: flex-start;
  gap: 4px;
  align-self: flex-start;
  margin: -2px 0 8px;
  font-size: 12px;
  line-height: 1.4;
  color: #4d4d56;
`
